import { render, staticRenderFns } from "./EntityBubble.vue?vue&type=template&id=331e0032&scoped=true&"
import script from "./EntityBubble.vue?vue&type=script&lang=js&"
export * from "./EntityBubble.vue?vue&type=script&lang=js&"
import style0 from "./EntityBubble.vue?vue&type=style&index=0&id=331e0032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e0032",
  null
  
)

export default component.exports